<template>
  <div class="forward">

    <Form class="form">
      <div class="padding-bottom-10 text-df point" @click="$router.go(-1)" >
       <i class="el-icon-arrow-left"></i> 返回
      </div>
      <div class="title">忘记登录密码</div>
      <div class="step">
        <div class="step-item" :class="{active:step === 1}">1 修改登录密码</div>
        <div class="step-item" :class="{active:step === 2}">2 设置新密码</div>
        <div class="step-item" :class="{active:step === 3}">3 重置成功</div>
      </div>
      <FormItem class="input-view" style="margin-top: 50px" v-if="step === 1">
        <Input placeholder="请输入您的手机号" v-model="loginForm.phone" number  :maxlength="11" >
          <span slot="prefix">
              <img src="../../assets/images/mobile.png" alt class="icon">
          </span>
        </Input>
      </FormItem>
      <FormItem class="input-view" v-if="step === 1">
        <Input placeholder="请输入验证码" number  :maxlength="6"  style="width: 230px" v-model="loginForm.code"></Input>
        <Button type="primary" style="width:150px;height: 40px;margin-left: 18px" @click="getCode()" :disabled="!show">
          <span v-if="show">获取验证码</span>
          <span v-if="!show">{{count}} s</span>
        </Button>
      </FormItem>
      <FormItem class="input-view" v-if="step === 2">
        <Input placeholder="请设置密码" type="password" :maxlength="16" v-model="loginForm.password"></Input>
      </FormItem>
      <FormItem class="input-view" v-if="step === 2">
        <Input placeholder="请再次输入密码" type="password"  :maxlength="16" v-model="loginForm.confirm_password"></Input>
      </FormItem>
      <div class="success" v-if="step === 3">
        <div class="success-icon">
          <img src="../../assets/images/ok.png" alt>
        </div>
        <span>重置成功，立即登录</span>
      </div>

      <Button type="primary" style="width: 100%;height: 48px;border-radius: 24px;margin-top: 40px" v-if="step === 1" @click="nextStep()">下一步</Button>
      <Button type="primary" style="width: 100%;height: 48px;border-radius: 24px;margin-top: 40px" v-if="step === 2" @click="define()">确认</Button>
      <Button type="primary" style="width: 100%;height: 48px;border-radius: 24px;margin-top: 40px" v-if="step === 3" @click="$router.push({name:'login'})">去登录</Button>
    </Form>
  </div>
</template>

<script>
import { isMobile } from '@/libs/validator'
export default {
  name: 'forward',
  data () {
    return {
      step: 1,
      show: true,
      count: 60,
      timer: null,
      loginForm: {
        phone: '',
        password: '',
        confirm_password: '',
        code: ''
      }
    }
  },
  methods: {
    getCode () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (!this.timer) {
        this.$request('610796cfa73ad', {
          phone: this.loginForm.phone + '',
          type: 'worker_edit_password'
        }).then(res => {
          this.show = false
          this.count = 60
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        })
      } else {
        return this.$message.error('请求验证码频繁')
      }
    },
    nextStep () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (this.loginForm.code == '') {
        return this.$message.error('请输入验证码')
      }
      this.step = 2
    },
    define () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (this.loginForm.code == '') {
        return this.$message.error('请输入验证码')
      }
      if (this.loginForm.password == '') {
        return this.$message.error('请输入密码')
      }
      if (this.loginForm.confirm_password == '') {
        return this.$message.error('请输入确认密码')
      }
      if (this.loginForm.password != this.loginForm.confirm_password) {
        return this.$message.error('两次密码不一致')
      }
      this.$request('6124bf8f294b2', {
        phone: this.loginForm.phone + '',
        code: this.loginForm.code + '',
        type: 1,
        password: this.loginForm.password
      }).then(res => {
        this.step = 3
      })
    }
  }
}
</script>

<style scoped lang="less">
.forward {
  position: absolute;
  width: 100%;
  height: 100%;
  flex: 1;
  background-image: url("../../assets/images/loginbg.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .step{
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    .step-item{
      width: 107px;
      height: 36px;
      border-radius: 10px 0 10px 0;
      background-color: #F7F7F7;
      text-align: center;
      line-height: 36px;
      color: #ABABAC;
    }
    .active{
      background-color: #FC8B03;
      color: #FFFFFF;
    }
  }

  .form {
    width: 480px;
    background-color: #FFFFFF;
    border-radius: 28px;
    padding: 60px 40px;

    .title {
      font-weight: 600;
      font-size: 30px;
      line-height: 50px;
    }

    .login-type {
      width: 100%;
      border-bottom: 1px solid #F7F7F7;
      display: flex;
      margin-top: 20px;

      .login-btn {
        height: 50px;
        line-height: 50px;
        margin-right: 30px;
        font-weight: 400;
        font-size: 18px;
        cursor: pointer;
      }

      .active {
        color: #FB9E2F;
        font-weight: 600;
        position: relative;

        &:after {
          content: '';
          width: 70px;
          height: 2px;
          background-color: #FB9E2F;
          position: absolute;
          bottom: -0.5px;
          left: 0;
        }
      }
    }

    .input-view {
      margin-top: 30px;

      .icon{
        width: 24px;
        margin-top: 7px;
      }
    }
  }

  .success{
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span{
      margin-top: 10px;
    }
  }
  .success-icon{
    width: 80px;
    height: 80px;
    background-color: #2CCC6C;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
  }
}
</style>
